// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle_pageTitle__ASBUq","pageTitleIcon":"PageTitle_pageTitleIcon__Gd56-"};